@if (isShowMore()) {
<div class="container">
  <button class="btn" [disabled]="isLoading()" (click)="onClick()">
    @if (isLoading()) {
    <span>{{ text().loadingText }}</span>
    } @else {
    <span>{{ text().showMoreText }}</span>
    }
  </button>
</div>
}